export default {
  methods: {
    async showErrorMessage (message = '', title = 'Error!') {
      this.$bvToast.toast(message, {
        title: title,
        variant: 'danger',
        solid: true
      })
    },
    async showSuccessMessage (
      message = 'Your operation has been completed successfully',
      title = 'Başarılı!'
    ) {
      this.$bvToast.toast(message, {
        title: title,
        variant: 'success',
        solid: true
      })
    },
    async showInfoMessage (message, title = 'Info') {
      this.$bvToast.toast(message, {
        title: title,
        variant: 'info',
        solid: true
      })
    }
  }
}
